
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {rulesApi} from "@/api/rules";
    import {IPage} from "@/js/page";
    @Component({
        name: 'SelectRules',
    })
    export default class SelectRules extends Vue {
        @Prop()
        private value !: any;     //传入的规程ID
        @Prop()
        private rowIndex !: any;//下标 可以不传
        @Prop()
        private rulesType !: any; // 0 地方 1国家 2共享 3其它
        @Prop()
        private dataObj !: any; // 编辑时的首次数据
        @Prop()
        private urlType !: any; // 接口类型  1是copy
        listParam: IPage = {
            size: 1000,
            current: 1,
        };
        rulesId = "" ;//当前选中的ID
        rulesList = [] as any;  //备选项
        created() {
            if(this.urlType == 1){
                this.rulesId = this.getRuleOptionValue(this.dataObj);
                if(this.dataObj && this.dataObj.number){
                    this.rulesList = [this.dataObj];
                }
            }else{
                this.rulesId = this.value;
                if(this.dataObj && this.dataObj.id){
                    this.rulesList = [this.dataObj];
                }
            }
        }
        remoteMethod(number: string) {
            if(number){
                setTimeout(() => {
                    this.page(number);
                }, 200);
            }else{
                this.rulesList = [];
            }
        }
        page(number: string){
            const params = {
                ...this.listParam,
                number :number,
                type: this.rulesType,
            }
            let api;
            if(this.urlType == 1){
                api = rulesApi.pageCopy(params);
            }else{
                api = rulesApi.list(params)
            }
            api.then(r => {
                if (r.data.result === 0) {
                  if(this.urlType == 1){
                    this.rulesList = r.data.data.records;
                  }else{
                    this.rulesList = r.data.data;
                  }
                }
            })
        }
        changeRules(){
            const data = this.rulesList.find((e:any) => (this.urlType==1?this.getRuleOptionValue(e):e.id) == this.rulesId);
            if(data){
                const data2 = this.cloneData(data);
                data2.rowIndex = this.rowIndex;
                if(this.urlType == 1){
                    data2.number = this.getRuleSaveNumber(data2);
                }
                this.$emit('onChange', data2);
            }
            if(!this.rulesId){
                this.remoteMethod("");
                this.$emit('onChange', {
                    rowIndex: this.rowIndex,
                    id: "",
                    number: "",
                    name: "",
                });
            }
        }
        cloneData(data: any){
            return JSON.parse(JSON.stringify(data));
        }
        getRuleOptionValue(data: any){
            if(!data){
                return this.value;
            }
            return data.id || data.number || "";
        }
        getRuleOptionLabel(data: any){
            if(!data){
                return "";
            }
            const number = data.fullNumber || data.full_number || data.number || "";
            return data.name ? (number + " " + data.name) : number;
        }
        getRuleSaveNumber(data: any){
            return data.number || this.removeRuleYear(data.fullNumber || data.full_number || "");
        }
        removeRuleYear(number: string){
            return number ? number.replace(/[-—][0-9]+(\\.[0-9]+)?$/, "") : "";
        }
        @Watch("value")
        valueChange(val: string) {
            if(this.urlType == 1){
                const selected = this.rulesList.find((e:any) => this.getRuleOptionValue(e) == this.rulesId);
                if(selected && this.getRuleSaveNumber(selected) == val){
                    return;
                }
            }
            this.rulesId = val;
        }
    }
